import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Link,
  TextField,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  IconButton,
  // CircularProgress,
} from '@material-ui/core';
import { useFormik } from 'formik';
import { Link as RouterLink } from 'react-router-dom';
import * as Yup from 'yup';
import styles from '../login.module.scss';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import oktaLogo from '../../../assets/images/okta.png';
import azureLogo from '../../../assets/images/azure.png';
import { ssoLoginEntity } from '../../../constants/applicationConstants';

const LoginForm = ({ handleLogin, isLoading }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const formik = useFormik({
    initialValues: {
      username: '',
      passwd: '',
      rememberme: false,
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Username is required'),
      passwd: Yup.string().required('Password is required')
        .min(8, 'Password must be at least 8 to 25 characters')
        .max(25, 'Password must be at least 8 to 25 characters'),
    }),
    onSubmit: (values) => handleLogin(values),
  });

  return (
    <Box
      component="form"
      marginTop={0}
      noValidate
      onSubmit={formik.handleSubmit}
      data-testid="login-form"
      autoComplete="off"
    >
      <TextField
        margin="normal"
        variant="outlined"
        required
        fullWidth
        id="username"
        label="Username"
        name="username"
        autoFocus
        disabled={isLoading}
        // value={formik.values.username}
        onChange={formik.handleChange}
        error={formik.touched.username && Boolean(formik.errors.username)}
        helperText={formik.touched.username && formik.errors.username}
      />
      <TextField
        margin="normal"
        variant="outlined"
        required
        fullWidth
        name="passwd"
        label="Password"
        type={showPassword ? 'text' : 'password'}
        id="passwd"
        autoComplete="current-password"
        disabled={isLoading}
        // value={formik.values.passwd}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.passwd && Boolean(formik.errors.passwd)}
        helperText={formik.touched.passwd && formik.errors.passwd}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                data-testid="toggle-password-visibility"
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Grid container style={{ marginTop: '15px' }}>
        <Grid item xs={6} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                id="rememberme"
                name="rememberme"
                checked={formik.values.rememberme}
                onChange={formik.handleChange}
              />
            }
            label={<span style={{fontSize: '14px'}}>Remember Me</span>}
          />
        </Grid>
        <Grid item xs={6} md={6} className={styles['forgot-password']}>
          <Link component={RouterLink} to={`/forgotPassword`} variant="body2">
            {'Forgot Password'}
          </Link>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: '15px' }} spacing={0} alignItems="center" justifyContent="center">
        <Grid item xs={8}>
          <Button
            type="submit"
            // disabled={isLoading}
            variant="contained"
            fullWidth
            color="primary"
            className={`${styles['login-btn']}`}
            data-testid="login-submit-btn"
          >
            <Box
              data-testid="login-submit"
              sx={{ fontWeight: 'bold' }}
            >{`Login`}</Box>
            {/* {isLoading && (
              <CircularProgress size={20} color="white" style={{marginLeft: '5px'}} />
            )} */}
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} className={styles['login-with-app']}>
        <span>or Log in with Corporate ID</span>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item className={styles['login-with-app-btn']}>
          <a
            style={{ float: 'left' }}
            id="login-with-sso"
            // className={}
            href={`${ssoLoginEntity.ssoLiginUrl}`}
            alt=""
          >
            <img alt="" src={oktaLogo} />
          </a>
        </Grid>
        <Grid item className={styles['login-with-app-btn']}>
        <a
            style={{ float: 'left' }}
            id="login-with-sso"
            // className={}
            href={`${ssoLoginEntity.azureLiginUrl}`}
            alt=""
          >
            <img alt="" src={azureLogo} />
          </a>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginForm;
